/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

